<script>
import HeaderFive from './../shared/HeaderFive.vue'
import Footer from './../shared/Footer.vue'
import { ShoppingCart, Location, Merchant, Account, util } from './../../functions.js';

export default {
  name: 'Order Confirmation',
  components: {
    Footer,
    HeaderFive
  },
  data () {
    return {
      order_result: null
    }
  },
  created()
  {
    this.order_result = JSON.parse(sessionStorage.getItem("order_success"));
    
    if(this.order_result)
    {
        // Clear Cart
        if(Account.getToken() != "" && Account.getLoginId() != "")
        {
            let cart_data = Object.assign([], ShoppingCart.cart[ShoppingCart.active_shopping_cart].products);
            cart_data.forEach((p,p_index)=>{
              ShoppingCart.removeFromCart(p.product, 0);
              console.log(p.product);
            });

            // ShoppingCart.deleteCart();
        }
        else
        {
            ShoppingCart.deleteCart();
        }


        this.order_result.delivery_fee = parseFloat(this.order_result.delivery_fee);

         // Transform Free Items Data
          var free_items = [];
          this.order_result.details.free_items.forEach((free, free_index)=>{
            var item_index = null;
            var added_quantity = 0;

            free_items.forEach((fi, fi_index)=>{
              if(free.product_name == fi.product_name)
              {
                item_index = fi_index;
                added_quantity = parseInt(fi.quantity);
              }
            });

            if(item_index == null)
            {
              free_items.push(free);
            }
            else
            {
              free_items[item_index].quantity = parseInt(free_items[item_index].quantity) + parseInt(added_quantity);
            }
          });

          this.order_result.details.free_item = free_items;

    }
  }
}
</script>

<template>
  <div class="page about-page">
      <HeaderFive />

    <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-image" data-bg="img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                           
                            <h1 class="section-title white-color">Order Success</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/">Home</router-link></li>
                                <li>Order Success</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- LOGIN AREA START -->
    <div class="ltn__login-area mb-120">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="account-login-inner section-bg-1">
                        <div class="ltn__form-box contact-form-box">
                            <h1 class="text-center">Your order has been successfully placed.</h1>
                           <div class=" order-details-body mb-5">
                                <div class="row justify-content-center">
                                    <div class="col-3">
                                        Order ID
                                    </div>
                                    <div class="col-8">
                                        {{ (order_result.order_id) }}
                                    </div>
                                </div>
                                <div class="row justify-content-center" >
                                    <div class="col-3">
                                        Order Items
                                    </div>
                                    <div class="col-8">
                                        <div class="row" v-for="merchant_order in order_result.details.result.merchant_orders">
                                            <div class="col-12" v-for="product in merchant_order.products_stat.cart">
                                                 <div class="product-info">{{ (product.total) | currencyFormat }} - {{ product.qty }} × <span class="text-truncate">{{ product.name }}</span></div>
                                            </div>
                                            <div class="col-12" v-for="free in order_result.details.free_item">
                                                 <div class="product-info">FREE - {{ free.quantity }} × <span class="text-truncate">{{ free.product_name }}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-3">
                                        Payment
                                    </div>
                                    <div class="col-8">
                                        {{ (order_result.details.result.net_total + order_result.delivery_fee)  | currencyFormat }}
                                    </div>
                                </div>
                                <div class="row justify-content-center" v-if="order_result.customer_note">
                                    <div class="col-12 text-center"><br>
                                        <h4>Delivery Instructions</h4>
                                        {{ order_result.customer_note}}
                                    </div>
                                </div>

                            </div>
                            <div class="btn-wrapper mt-0 text-center">
                                <router-link class="btn theme-btn-1 btn-effect-1 text-uppercase" :to="{ name:'orderTracking', query:{ 'email' : order_result.email, 'order': order_result.order_id } }">Track your Order</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- LOGIN AREA END -->

    <Footer />
  </div>
</template>
<style scoped>
.product-info {
    display: flex;
    align-items: center;
    padding: 0;
}

.product-info span {
    display: inline-block;
    max-width: 300px;
    margin-left: 5px;
    margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/OrderConfirmation.vue